import React from 'react';
import ChipAlert from '../Chip/ChipAlert';
import ChipDevice from '../Chip/ChipDevice';
import ChipSetting from '../Chip/ChipSetting';
import { withTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import 'react-datepicker/dist/react-datepicker.css';

import CustomCalendar from '../../pages/summaryReport/components/DatePicker/CustomCalendar';
import * as moment from 'moment';
import config from '../../config';
import * as Colors from '../../themes/summaryReportColor';

const getAlertInfo = (value, t) => {
  let result = `${t('unknown')}`;
  switch (value) {
    case 1:
      result = `${t('lying')}`;
      break;
    case 2:
      result = `${t('sitting')}`;
      break;
    case 3:
      result = `${t('standing')}`;
      break;
    case 4:
      result = `${t('walking')}`;
      break;
    case 5:
      result = `${t('Running')}`;
      break;
    case 6:
      result = `${t('Jumping')}`;
      break;
    case 7:
      result = `${t('lying_on_back')}`;
      break;
    case 8:
      result = `${t('lying_on_stomach')}`;
      break;
    case 9:
      result = `${t('lying_on_left_side')}`;
      break;
    case 10:
      result = `${t('lying_on_right_side')}`;
      break;
    case 501:
      result = `${t('get_up')}`;
      break;
    case 502:
      result = `${t('movement')}`;
      break;
    case 503:
      result = `${t('low_battery')}`;
      break;
    case 504:
      result = `${t('no_signal')}`;
      break;
    case 505:
      result = `${t('alert_router_no_signal')}`;
      break;
    case 506:
      result = `${t('alert_not_turn')}`;
      break;
    case 507:
      result = `${t('alert_no_movement')}`;
      break;
    case 508:
      result = `${t('alert_fall')}`;
      break;
    case 509:
      result = `${t('out_of_area')}`;
      break;
    case 510:
      result = `${t('in_to_area')}`;
      break;
    case 511:
      result = `${t('alert_walking')}`;
      break;
    case 512:
      result = `${t('alert_deactivate_recharge')}`;
      break;
    case 513:
      result = `${t('alert_bad_signal')}`;
      break;
    case 514:
      result = `${t('alert_emergency_alarm')}`;
      break;
    default:
      break;
  }
  return result;
};

const getAlerts = (patient) => {
  let alerts = [];
  if (patient && patient.devices && patient.devices.length > 0) {
    let alertsCritical = [];
    let alertsWarning = [];
    let alertsWarningInfo = [];

    patient.devices.forEach((d) => {
      if (d.action && d.action.alerts && d.action.alerts.length > 0) {
        d.action.alerts.forEach((a) => {
          if (a.alertCritical === 'true') {
            a.alertColor = 'critical';
            alertsCritical.push(a);
          } else if (a.alertWarning === 'true' && ![503, 504, 512].includes(a.alertType)) {
            a.alertColor = 'warning';
            alertsWarning.push(a);
          } else if (a.alertWarning === 'true' && [503, 504, 512].includes(a.alertType)) {
            a.alertColor = 'info';
            alertsWarningInfo.push(a);
          }
        });
      }
    });

    alertsCritical = sortAlerts(alertsCritical);
    alertsWarning = sortAlerts(alertsWarning);
    alertsWarningInfo = sortAlerts(alertsWarningInfo);
    // concat data
    alerts = alertsCritical.concat(alertsWarning, alertsWarningInfo);
  }
  return {
    showAlerts: alerts.slice(0, 3),
    hideAlerts: alerts.slice(3),
  };
};

const sortAlerts = (alerts) => {
  return alerts.sort((a, b) => {
    if (a.alertPriority < b.alertPriority) return -1;
    else if (a.alertPriority > b.alertPriority) return 1;
    else if ((a.alertPriority = b.alertPriority)) {
      if (a.alertTime > b.alertTime) return -1;
      else if (a.alertTime < b.alertTime) return 1;
      return 0;
    }
    return 0;
  });
};

const getSettingInfo = (value, t) => {
  let result = '';
  switch (value) {
    case 'walkingAt':
      result = `${t('walking_at_night')}`;
      break;
    case 'getup':
      result = `${t('get_up')}`;
      break;
    case 'notTurnFor':
      result = `${t('not_turn_for')}`;
      break;
    case 'movement':
      result = `${t('movement')}`;
      break;
    case 'noMovementFor':
      result = `${t('no_movement')}`;
      break;
    case 'lowBattery':
      result = `${t('low_battery')}`;
      break;
    case 'noSignal':
      result = `${t('no_signal')}`;
      break;
    case 'fall':
      result = `${t('fall')}`;
      break;
    case 'outOfArea':
      result = `${t('out_of_area')}`;
      break;
    case 'intoArea':
      result = `${t('in_to_area')}`;
      break;
    default:
      break;
  }
  return result;
};

const getFullname = (language, patient) => {
  let fullname = '';
  if (patient) {
    if (language && language === 'th-TH') {
      if (patient.firstname || patient.lastname) {
        fullname = `${patient.firstname ?? ''} ${patient.lastname ?? ''}`;
      } else {
        fullname = `${patient.firstnameEn ?? ''} ${patient.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (patient.firstnameEn || patient.lastnameEn) {
        fullname = `${patient.firstnameEn ?? ''} ${patient.lastnameEn ?? ''}`;
      } else {
        fullname = `${patient.firstname ?? ''} ${patient.lastname ?? ''}`;
      }
    }
    return fullname;
  }
};

const getKeyByValue = (object, value, t) => {
  let result = [];
  Object.keys(object).forEach((key) => {
    if (object[key] === value) {
      let setting = getSettingInfo(key, t);
      if (key !== 'movementLevel') {
        result.push(setting);
      }
    }
  });
  return result;
};

const isEmergencyDevice = (deviceVersion) => {
  if (deviceVersion) {
    const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
    if (property) {
      if (property.alarmTrigger || property.alarmOnoff) {
        return true;
      }
    }
  }
  return false;
};

const isShowBattery = (action) => {
  const currentDateTime = moment();
  const batterryDateTime = moment(action.batteryTimestamp ? action.batteryTimestamp : action.timestamp);
  const diffTime = currentDateTime.diff(batterryDateTime, 'minutes');
  return diffTime <= config.battery.hideBatteryAfter;
};

const getWarningSettingformDevice = (setting, hasAirnode, t) => {
  const warningSettingWithoutAirnode = {};
  const settingWithoutAirnode = ['intoArea', 'outOfArea', 'noSignal', 'lowBattery'];
  settingWithoutAirnode.forEach((s) => {
    warningSettingWithoutAirnode[s] = setting[s] ? setting[s] : null;
  });
  const warningSetting = getKeyByValue(hasAirnode ? setting : warningSettingWithoutAirnode, 1, t);
  return warningSetting;
};

const FormLabel = (props) => {
  return (
    <div className='flex mt-3 mr-3'>
      <div className='text-base not-italic font-medium text-secondary'>
        {props.title}
        {':'}
      </div>
      <div className='flex mx-1 text-base font-normal text-secondary'>{props.label ? props.label : '-'}</div>
    </div>
  );
};

const InfoLegend = (props) => (
  <div className='flex flex-col max-w-xs mb-1'>
    {props.data.map((d, i) => (
      <div className='flex p-1' key={i}>
        <svg width={20} height={20}>
          <circle cx='50%' cy='50%' r='7' fill={d.color} />
        </svg>
        <div className='block w-32 ml-2 text-left'>
          <span className='text-xs text-black'>{d.label}</span>
        </div>
      </div>
    ))}
  </div>
);

const PatientInfo = (props) => {
  const { t } = props;
  // get warning setting
  const setting =
    props.patient && props.patient.warningSetting
      ? getWarningSettingformDevice(props.patient && props.patient.warningSetting, props.hasActivity, t)
      : [];
  let showSettings = setting.slice(0, 3);
  let hideSettings = setting.slice(3);

  const uniqueAlerts = [];
  const alertTypeIds = ((props.patient && props.patient.devices) || [])
    .filter((v) => v.action && v.action.alertType)
    .map((v) => v.action.alertType);
  if (alertTypeIds.length > 0) {
    const uniqueAlertIds = Array.from(new Set(alertTypeIds));
    uniqueAlertIds.forEach((id) => {
      const device = props.patient && props.patient.devices.find((d) => d.action.alertType === id);
      if (device) {
        uniqueAlerts.push(device);
      }
    });
  }

  const colorDef = [
    { label: 'AiR', color: Colors.COLOR_DEVICE_AIRNODE },
    { label: 'Emergency Button', color: Colors.COLOR_DEVICE_EMERGENCY },
    { label: 'Vital Signs', color: Colors.COLOR_VITALSIGN },
  ];

  const data = getAlerts(props.patient);
  return (
    <div className='block'>
      <div className='block md:flex lg:flex xl:flex'>
        <div className='text-3xl font-semibold text-summary-header'>
          {getFullname(localStorage.getItem('i18nextLng'), props.patient)}
        </div>
        <div className='flex items-center justify-start flex-initial w-1/2 ml-2'>
          {data.showAlerts.map((a, i) => (
            <ChipAlert key={i} alertColor={a.alertColor} onAcknowledge={props.onAcknowledge} alert={a}>
              {getAlertInfo(a.alertType, t)}
            </ChipAlert>
          ))}
          <div className='relative'>
            {data.hideAlerts.length > 0 && (
              <div className='cursor-pointer'>
                <ChipSetting onClick={props.handleAlert} color={data.hideAlerts[0].alertColor}>
                  +{data.hideAlerts.length}
                </ChipSetting>
              </div>
            )}
            {data.hideAlerts.length > 0 && props.isAlert && (
              <div className='absolute z-10 w-auto h-auto mt-1 -ml-8 bg-white border rounded shadow-lg'>
                <div className='relative flex-auto px-2 pt-4 pb-2'>
                  <span className='absolute top-0 right-0 p-2'>
                    <button
                      className='cursor-pointer focus:outline-none'
                      aria-label='close'
                      onClick={(e) => props.handleAlert(e)}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='w-5 h-5'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path
                          fillRule='evenodd'
                          d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                          clipRule='evenodd'
                        />
                      </svg>
                    </button>
                  </span>
                  <div className='relative block mt-2'>
                    {data.hideAlerts.map((a, i) => (
                      <div className='p-1' key={i}>
                        <ChipAlert
                          key={i}
                          alertColor={a.alertColor}
                          onAcknowledge={props.onAcknowledge}
                          alert={a}
                          clearAlert={data.hideAlerts.length === 1 ? true : false}
                        >
                          {getAlertInfo(a.alertType, t)}
                        </ChipAlert>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='flex justify-end flex-initial text-right'>
          <CustomCalendar
            date={props.date}
            onDateChange={props.onDateChange}
            dateMotionTracker={props.dateMotionTracker}
            dateSOS={props.dateSOS}
            dateBeaconTag={props.dateBeaconTag}
            dateVitalSigns={props.dateVitalSigns}
            includeDates={props.includeDate}
            today={props.today}
          />
          <div className='relative m-1'>
            <IconButton aria-label='info' id='info' className='w-5 h-5' onClick={props.openedInfo}>
              <InfoOutlined />
            </IconButton>
            {props.isInfo && (
              <div className='absolute z-10 h-auto bg-white border rounded shadow-lg w-36'>
                <div className='flex p-2 text-sm font-medium text-summary-header'>Color Definition</div>
                <InfoLegend data={colorDef} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='flex'>
        <div className='flex'>
          <FormLabel title={t('age')} label={props.patient && props.patient.age ? props.patient.age : '-'} />
          <FormLabel title={t('weight')} label={props.patient && props.patient.weight} />
          <FormLabel title={t('height')} label={props.patient && props.patient.height} />
          <FormLabel
            title={t('bmi')}
            label={
              props.patient &&
              props.patient.weight &&
              props.patient.height &&
              (props.patient.weight / ((props.patient.height * props.patient.height) / 10000)).toFixed(2)
            }
          />
        </div>
      </div>

      <div className='xl:flex lg:flex md:block sm:block'>
        {props.devices && props.devices.length > 0 && (
          <FormLabel
            title={t('devices')}
            label={props.devices.map((val) => (
              <div className='flex justify-end mx-1' key={val.id}>
                <ChipDevice
                  action={val.action}
                  status={val.status}
                  level={val.action && val.action.changed && val.action.changed.b}
                  isEmergency={isEmergencyDevice(val.deviceVersion)}
                  isShowBattery={val.action && isShowBattery(val.action)}
                  t={t}
                >
                  {val.name}
                </ChipDevice>
              </div>
            ))}
          />
        )}
        {props.devices && props.devices.length > 0 && (
          <FormLabel
            title={t('alert_setting')}
            label={
              <div className='flex justify-end'>
                {showSettings.map((val, i) => (
                  <ChipSetting key={i} color='critical'>
                    {val}
                  </ChipSetting>
                ))}
                {hideSettings.length > 0 && (
                  <div className='cursor-pointer'>
                    <ChipSetting color='critical' onClick={props.handleSetting}>
                      +{hideSettings.length}
                    </ChipSetting>
                  </div>
                )}
              </div>
            }
          />
        )}
      </div>
      {props.isSetting ? (
        <div
          className='absolute z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none'
          style={{
            left: '45%',
          }}
        >
          <div className='relative w-auto max-w-sm mx-auto my-6'>
            <div className='relative flex flex-col w-full bg-white border rounded shadow-lg outline-none focus:outline-none'>
              <div className='relative flex-auto p-4'>
                <span className='absolute top-0 right-0 p-2'>
                  <button
                    className='cursor-pointer focus:outline-none'
                    aria-label='close'
                    onClick={(e) => props.handleSetting(e)}
                  >
                    <svg xmlns='http://www.w3.org/2000/svg' className='w-5 h-5' viewBox='0 0 20 20' fill='currentColor'>
                      <path
                        fillRule='evenodd'
                        d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                        clipRule='evenodd'
                      />
                    </svg>
                  </button>
                </span>
                <div className='block'>
                  {hideSettings.map((val, i) => (
                    <div className='p-1' key={i}>
                      <ChipSetting color='critical'>{val}</ChipSetting>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export const translation = withTranslation()(PatientInfo);
export default translation;
